<template>
  <div>
    <b-form @submit.prevent.stop="validForm">
      <div class="row">
        <b-form-group
          class="col-4"
          id="input-group-1"
          label="Produto"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="produto.nome"
            :class="{
              'is-invalid': formsubmit && $v.produto.nome.$error,
            }"
            type="text"
            placeholder="Digite o nome do produto"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="col-4"
          id="input-group-2"
          label="Quantidade"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="produto.qtde_unitaria"
            :class="{
              'is-invalid': formsubmit && $v.produto.qtde_unitaria.$error,
            }"
            type="number"
            placeholder="Quantidade"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="col-4"
          id="input-group-2"
          label="Unidade"
          label-for="input-2"
        >
          <b-form-select
            id="input-2"
            v-model="produto.unidade"
            type="text"
            placeholder="Unidade de medida"
            :options="unidades"
            :class="{
              'is-invalid': formsubmit && $v.produto.unidade.$error,
            }"
            required
          ></b-form-select>
          <!-- <b-form-input
            id="input-2"
            v-model="produto.unidade"
            :class="{
              'is-invalid': formsubmit && $v.produto.unidade.$error,
            }"
            type=""
            placeholder="Unidade de medida"
          ></b-form-input> -->
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          class="col-4"
          id="input-group-1"
          label="Valor"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="produto.valor"
            :class="{
              'is-invalid': formsubmit && $v.produto.valor.$error,
            }"
            v-money="money"
            type="text"
            placeholder="Valor unitário"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="col-4"
          id="input-group-2"
          label="Categoria do Produto no Site"
          label-for="input-2"
        >
          <b-form-select
            id="input-2"
            v-model="produto.categoria"
            type="text"
            placeholder="Categoria do produto"
            :options="categorias"
            :class="{
              'is-invalid': formsubmit && $v.produto.categoria.$error,
            }"
            required
          ></b-form-select>
          <!-- <b-form-input
            id="input-2"
            v-model="produto.categoria"
            :class="{
              'is-invalid': formsubmit && $v.produto.categoria.$error,
            }"
            type=""
            placeholder="Categoria do produto"
          ></b-form-input> -->
        </b-form-group>
      </div>
      <div class="row">
        <div v-if="produto.imagem" class="col-3">
          <img :key="keyindex" class="image" :src="produto.imagem" alt="">
          <p 
            @click="removeImage" 
            class="remove-cross"
            v-b-tooltip.hover
            title="Remover"
          >X</p>
        </div>
        <b-form-group
          class="col-4"
          id="input-group-1"
          label="Imagem" 
          label-for="input-1"
          v-else
        >
          <input @change="previewFiles" type="file" id="file" />
        </b-form-group>
      </div>
      <div class="row" v-if="!produto._id">
        <b-form-group
          class="col-4"
          id="input-group-1"
          label="Estoque inicial"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="produto.estoque"
            :class="{
              'is-invalid': formsubmit && $v.produto.estoque.$error,
            }"
            type="number"
            placeholder="Estoque inicial"
          ></b-form-input>
        </b-form-group>
      </div>
      <b-button type="submit" variant="primary">Salvar</b-button>
    </b-form>
  </div>
</template>
<script>
import { VMoney } from 'v-money'
import { required } from 'vuelidate/lib/validators'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  directives: { money: VMoney },
  mixins: [alertMixin],
  props: {
    produto: {
      type: Object,
      require: true,
    },
    salvar: {
      type: Function,
    },
    formsubmit: {
      type: Boolean,
    },
    keyindex: {
      type: Number
    }
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      tiposContas: ['admin', 'operador'],
      unidades:['KG', 'LT', 'UN', 'BANDEJA', 'MOLHO'],
      categorias:['OFERTAS', 'FRUTAS', 'VERDURAS', 'LEGUMES', 'ESPECIARIAS', 'DESCARTAVEIS', 'DIVERSOS'],
    }
  },
  validations: {
    produto: {
      nome: { required },
      valor: { required },
      estoque: { required },
      qtde_unitaria: { required },
      unidade: { required },
      categoria: { required },
    },
  },
  methods: {
    invalidForm() {
      this.errorMessage('Há campos que não foram preenchidos')
      this.formsubmit = true
    },
    validForm() {
      this.$v.$touch()
      !this.$v.produto.$error ? this.salvar() : this.invalidForm()
    },
    previewFiles(e) {
      this.$emit('previewFiles', e)
      setTimeout(() => {
        this.keyindex += 1
      }, 700);
    },
    removeImage(){
      this.produto.imagem = null
      this.keyindex += 1
    }
  },
}
</script>
<style scoped>
.image{
  width: 250px;
}
.remove-cross:hover{
  cursor: pointer;
}
.remove-cross{
  top: 0px;
  right: 0px;
  font-size: 20px;
  font-weight: bolder;
  padding: 5px;
  position: absolute;
  color: brown;
}
</style>
